// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hfzaY","right":"styles_right__1QddT"};